import { Button, Portal, Popover, Tabs } from "@chakra-ui/react";

import { LuLayers3, LuLayers, LuFolders } from "react-icons/lu";

import Projects from "./project";
import { Tooltip } from "./../../../ui/tooltip";

import Layers from "./layer";
import { useAppStore } from "../../../../context/store";
const AddonsMenu = ({ droppedFiles }) => {
  // state
  const isOpenAddonsMenu = useAppStore((s) => s.isOpenAddonsMenu);
  const layerTab = useAppStore((s) => s.layerTab);

  // setters
  const setIsOpenAddonsMenu = useAppStore.getState().setIsOpenAddonsMenu;
  const setLayerTab = useAppStore.getState().setLayerTab;

  return (
    <Popover.Root
      positioning={{ placement: "left-start" }}
      open={isOpenAddonsMenu}
      onOpenChange={(e) => {
        setIsOpenAddonsMenu(e.open);
      }}
      closeOnInteractOutside={false}
    >
      <Popover.Trigger asChild>
        <Button p={2} width={"45px"} height={"45px"} bg={isOpenAddonsMenu ? "green" : "white"} color={isOpenAddonsMenu ? "white" : "MenuText"}>
          <Tooltip content={"Layers & Projects"}>
            <LuLayers3 color={isOpenAddonsMenu ? "white" : "MenuText"} />
          </Tooltip>
        </Button>
      </Popover.Trigger>
      <Portal>
        <Popover.Positioner>
          <Popover.Content width={"500px"} height={"80vh"} zIndex={1001} borderRadius={10} mt={"-100px"}>
            <Popover.Arrow mt={"50px"} />

            <Popover.Body p={0} px={1} pb={1} display="flex" flexDir="column" h="100%">
              <Tabs.Root value={layerTab} onValueChange={(e) => setLayerTab(e.value)} defaultValue="projects" display="flex" flexDir="column" h="100%">
                <Tabs.List width={"full"} mt={2}>
                  <Tabs.Trigger value="projects" width={"50%"} justifyContent={"center"}>
                    <LuFolders />
                    Projects
                  </Tabs.Trigger>
                  <Tabs.Trigger value="layers" width={"50%"} justifyContent={"center"}>
                    <LuLayers />
                    Layers
                  </Tabs.Trigger>
                </Tabs.List>
                <Tabs.Content value="layers" flex="1" minH={0} pt={0} px={1} display="flex" flexDir="column">
                  <Layers droppedFiles={droppedFiles} />
                </Tabs.Content>
                <Tabs.Content value="projects" flex="1" minH={0} pt={0} px={1} display="flex" flexDir="column">
                  <Projects />
                </Tabs.Content>
              </Tabs.Root>
            </Popover.Body>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
};

export default AddonsMenu;
